// AUTO-GENERATED by scripts/write-build-version.ts — do not edit.
// Empty string = version key disabled (current/pre-deploy-skew behaviour).
export const BUILD_VERSION = "5f1f95722fa294b9f73307b52d927bb6";
// The git sha, ALWAYS — BUILD_VERSION is a render-identity hash under
// CACHE_NAMESPACE_PIN=1 and cannot be compared against a commit.
export const BUILD_COMMIT = "faf7de234866";
